import { render } from "./CollectionList.vue?vue&type=template&id=7bd057fe&scoped=true&ts=true"
import script from "./CollectionList.vue?vue&type=script&lang=ts"
export * from "./CollectionList.vue?vue&type=script&lang=ts"

import "./CollectionList.vue?vue&type=style&index=0&id=7bd057fe&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd057fe"]])

export default __exports__